import resolveSingleSelectionProductIds from './resolveSingleSelectionProductIds';

const toDetailsProduct = (productId, variantId) => {
  if (!productId) return null;
  return {
    productId,
    variantId: variantId || null,
  };
};

export default function resolveDetailsPanelProduct({
  selection,
  searchItems = [],
  activeProduct,
} = {}) {
  if (selection?.keys?.length === 1) {
    const entry = selection.byKey?.[selection.keys[0]] || null;
    const searchHit = (searchItems || []).find((item) => item._id === entry?._id)
      || null;
    const ids = resolveSingleSelectionProductIds(entry, searchHit);
    const resolved = toDetailsProduct(ids.productId, ids.variantId);
    if (resolved) return resolved;
  }

  return toDetailsProduct(activeProduct?.productId, activeProduct?.variantId);
}
